var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 33,
    viewBox: "0 0 46 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9101 16.3025C24.9101 20.8547 21.2397 24.545 16.7123 24.545C12.1848 24.545 8.51416 20.8547 8.51416 16.3025C8.51416 11.7502 12.1846 8.05957 16.7123 8.05957C21.24 8.05957 24.9101 11.7502 24.9101 16.3025Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9032 16.302C33.9032 20.587 32.068 24.062 29.8041 24.062C27.5403 24.062 25.7051 20.587 25.7051 16.302C25.7051 12.017 27.54 8.54199 29.8039 8.54199C32.0677 8.54199 33.9029 12.0159 33.9029 16.302",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5817 16.3024C37.5817 20.1407 36.9364 23.2541 36.1401 23.2541C35.3438 23.2541 34.6987 20.1415 34.6987 16.3024C34.6987 12.4632 35.3441 9.35059 36.1401 9.35059C36.9361 9.35059 37.5817 12.4629 37.5817 16.3024Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.bb4fa608de139ab12c3f9820249c5da8.svg";
export { ForwardRef as ReactComponent };